<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-05 15:31:10
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-09-05 15:38:25
 * @FilePath: \合联\oms\src\view\branch_finance\locationDetailsNew\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Page />
</template>

<script>
import Page from "@/view/finances/storageFeeNew/index.vue";
export default {
  name: "locationDetailsNew",
  components: {
    Page,
  },
};
</script>

<style>
</style>
